import React from "react";
import { Space, Tag } from "antd";

const defaultFilterLabelMap = {
    institutionName: "Байгууллага",
    transactionDate: "Огноо",
    senderName: "Шилжүүлэгч",
    requestNumber: "Хүсэлтийн дугаар",
    payer: "Төлөгч",
    beneficiaryCompany: "Хүлээн авагч",
    parentDisplayStatus: "Ерөнхий төлөв",
    confirmedAt: "Баталгаажуулсан огноо",
    confirmedBy: "Баталгаажуулсан",
    ignoredAt: "Тэмдэглэсэн огноо",
    ignoredBy: "Тэмдэглэсэн",
    currency: "Валют",
    receivingAccountNumber: "Хүлээн авсан данс",
    beneficiaryBank: "Хүлээн авагч банк",
    beneficiaryAccount: "Хүлээн авагчийн данс",
    fillType: "Бөглөлт",
    allocationCheckStatus: "Шалгалтын төлөв",
    matchedOutgoingAt: "Гарсан огноо",
    returnDeadline: "Буцаах эцсийн хугацаа",
    manualFilledAt: "Гараар бөглөсөн огноо",
    actionType: "Үйлдэл",
    transactionScheduleAllocationId: "Хуваарилалтын ID",
};

function normalizeSorter(sorter) {
    if (!sorter) return null;
    if (Array.isArray(sorter)) {
        return sorter.find((x) => x?.order) || null;
    }
    return sorter?.order ? sorter : null;
}

function TableMetaBar({
    totalCount = 0,
    visibleCount = null,
    filters = {},
    sorter = null,
    filterLabelMap = {},
    totalLabel = "Нийт мөр",
    visibleLabel = "Харагдаж буй",
}) {
    const mergedLabelMap = { ...defaultFilterLabelMap, ...filterLabelMap };
    const activeSorter = normalizeSorter(sorter);

    const activeFilters = Object.entries(filters || {}).filter(([, value]) => {
        if (Array.isArray(value)) return value.length > 0;
        return value !== null && value !== undefined && value !== "";
    });

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 8,
                marginBottom: 12,
            }}
        >
            <Space wrap>
                <Tag color="blue">
                    {totalLabel}: {totalCount}
                </Tag>
                <Tag color="green">
                    {visibleLabel}: {visibleCount ?? totalCount}
                </Tag>
            </Space>

            <Space wrap>
                {activeFilters.map(([key, value]) => {
                    const label = mergedLabelMap[key] || key;
                    const text = Array.isArray(value) ? value.join(", ") : String(value);

                    return (
                        <Tag key={key} color="processing">
                            {label}: {text}
                        </Tag>
                    );
                })}

                {activeSorter ? (
                    <Tag color="purple">
                        Эрэмбэ: {mergedLabelMap[activeSorter.field || activeSorter.columnKey] ||
                            activeSorter.field ||
                            activeSorter.columnKey}{" "}
                        ({activeSorter.order === "ascend" ? "өсөх" : "буурах"})
                    </Tag>
                ) : null}
            </Space>
        </div>
    );
}

export default TableMetaBar;